module.exports = __webpack_public_path__ + "static/media/dong-son_preview.19b43c0d.png";